import React, { useEffect, useState } from "react";
import { useField } from "formik";
import { Col, Row } from "react-bootstrap";

// Create a selection box with error detection using Formik hooks
export const GeneralSelect = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    const [validationCheck, setValidationCheck] = useState("");

    // Sets up bootstrap validation styling
    useEffect(() => {
        if (meta.touched && meta.error) {
            setValidationCheck("is-invalid");
        } else if (meta.touched && !meta.error) {
            setValidationCheck("is-valid");
        }
    }, [meta.touched, meta.error]);

    return (
        <>
            <Col xs={12}>
                <Row>
                    <label
                        className="label px-0 mx-0 "
                        htmlFor={props.id || props.name}
                    >
                        {label}
                    </label>
                </Row>
                <Row>
                    <select
                        className={"form-control" + " " + validationCheck}
                        {...field}
                        {...props}
                    />
                </Row>

                {!meta.touched && meta.error ? (
                    <p className="text-danger py-0 my-0 ">{meta.error}</p>
                ) : null}
            </Col>
            {meta.touched ? (
                <p className="text-danger py-0 my-0 ">{meta.error}</p>
            ) : null}
        </>
    );
};
